export class MailTemplateAPIModel {
  GetMailTemplateListAPI: string = "";
  GetMailTemplateDetailsAPI: string = "";
  StageStatusAPI: any;
  PublishersAPI: any;
  JournalsAPI: any;
  CountryLanguageListApi: any;
  UpdateMailtempAPI: any;
}
